<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span>{{ $t("inventory-import.import") }}</span>
      </h2>

      <h6 class="mt-2">{{ $t("common.language") }}</h6>
      <multiselect
        v-model="form.language"
        track-by="language"
        :placeholder="$t('common.language-select')"
        :options="languages"
        :searchable="false"
        :allow-empty="false"
        :show-labels="false"
      >
        <template slot="singleLabel" slot-scope="{ option }">
          <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
          <span class="align-middle">{{ option.title | translate }}</span>
        </template>
        <template slot="option" slot-scope="{ option }">
          <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
          <span class="align-middle">{{ option.title | translate }}</span>
        </template>
      </multiselect>

      <file-rocket
        ref="inventoryImport"
        show-progress="Upload"
        class="mt-3"
        :allowedFormats="allowedFormats"
        @response="handleUploadResponse"
        :payload="this.form"
        :hidden="true"
        :maxFileSize="52428800"
        :targetUrl="targetUrl"
      ></file-rocket>

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>

  <!-- form input end -->
</template>

<script>
import { required } from "vuelidate/lib/validators";

import FileRocket from "@c/form/file-rocket";

const state = "managementInventoryImport";

export default {
  props: {
    closeOnSave: { type: Boolean, default: true },
  },
  components: { FileRocket },
  data() {
    return {
      form: {
        language: undefined,
        organizationId: undefined,
      },
      allowedFormats: [
        "application/vnd.ms-excel", // .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ], // .xlsx],
      formError: undefined,
    };
  },
  validations: {
    form: {
      language: {
        required,
      },
    },
  },
  watch: {},
  computed: {
    targetUrl() {
      return `/management/inventory/import`;
    },
    languages() {
      return this.$store.getters["localization/languages"];
    },
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },

    isFileSelected() {
      const files = this.$refs?.inventoryImport?.selectedFiles;
      if (files && files.length > 0) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.form = {
      ...this.form,
      ...this.language,
      organizationId: this.$route.params.id,
      language: this.languages.find((l) => l.language == this.currentAccount.language),
    };
  },
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        this.form.language = this.form.language?.language;
        await this.$refs?.inventoryImport?.uploadFiles();

        this.form = { organizationId: this.$route.params.id, language: this.languages.find((l) => l.language == this.currentAccount.language) };
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-import-inventory");
        }
      } catch (error) {
        this.$toast.error(error?.data?.message);
      }
    },

    async handleUploadResponse(event) {
      if (!this.isUploading) {
        if (event && event?.status !== 200) {
          this.$toast.error(event?.error?.data?.message || this.$t("common.failed"));
        } else {
          const job = event.data;
          this.$store.commit("managementInventoryImport/jobItems", []);
          this.$store.commit("managementInventoryImport/selectedJob", job);
          this.$toast.success(this.$t("common.success"));
        }

        // await this.reloadWithId(this.form._id);
      }
    },
  },
};
</script>
